import { isEmailAddress } from '@ikegps/core-shared';
import { action, computed, observable, makeObservable } from 'mobx';
import { T, Translate } from '../../i18n';
import { Services } from '../../services';

export class MigrateUserController {
	@observable inFlight: boolean = false;
	@observable value: string = '';
	@observable isDirty: boolean = false;
	@observable isValid: boolean = MigrateUserController.validateEmail(this.value);
	@observable formError: string | null = null;
	@observable hasSubmitted: boolean = false;
	@observable isNewUser: boolean | null = null;

	constructor() {
		makeObservable(this);
	}

	static validateEmail(str: string) {
		return typeof str === 'string' && isEmailAddress(str);
	}

	@action.bound async submit() {
		this.inFlight = true;
		this.formError = null;

		try {
			this.isNewUser = (
				await Services.Rest.rest.SSOUser.selfMigrate({
					email: this.value,
				})
			).isNewUser;
			this.hasSubmitted = true;
		} catch (_e) {
			this.formError = Translate(T.SSO_MIGRATE_FAILED);
		} finally {
			this.inFlight = false;
		}
	}

	@computed get hasError(): boolean {
		return this.isDirty && !this.isValid;
	}
}
